import React from 'react';
import { DatePickerSxStyles } from './styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';

interface CustomDatePickerProps {
	label: string;
	value: Dayjs | null;
	onChange: (newValue: Dayjs | null) => void;
	disabled?: boolean;
}

export const CustomDatePicker: React.FC<CustomDatePickerProps> = ({ label, value, onChange, disabled }) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
				label={label}
				format='DD/MM/YYYY'
				defaultValue={value}
				onChange={onChange}
				disabled={disabled}
				sx={{
					width: '200px',
					...DatePickerSxStyles(),
				}}
			/>
		</LocalizationProvider>
	);
};

export const CustomTimePicker: React.FC<CustomDatePickerProps> = ({ label, value, onChange, disabled }) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<TimePicker
				label={label}
				defaultValue={dayjs(value, 'HH:mm')}
				format='HH:mm'
				onChange={onChange}
				disabled={disabled}
				sx={{
					width: '200px',
					borderColor: '#d3d3d3',
					...DatePickerSxStyles(),
				}}
			/>
		</LocalizationProvider>
	);
};
